import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FundOffering } from '../../services/fund-offering/fund-offering';
import { OfferingStatus } from '../../enums/fund-status';
import { ROUTE_PATHS } from '../../utils/route-paths.const';
import { FUND_DETAILS_TABS } from '../../constants/tab-names.const';

export const addInvestmentGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const fundOfferingService = inject(FundOffering);
  const router = inject(Router);
  const fundUuid = route.paramMap.get('fundUuid');
  const offeringUuid = route.paramMap.get('offeringUuid');

  if (!fundUuid || !offeringUuid) {
    router.navigate([ROUTE_PATHS.ROOT]);
    return of(false);
  }

  // Check if navigation is from an offer-details page that already validated
  // the offer's state before showing the "Add Investment" button.
  const navigation = router.currentNavigation();
  const bypassGuard = navigation?.extras?.state?.['bypassGuard'];

  if (bypassGuard) {
    return of(true);
  }

  return fundOfferingService.getOfferingDetails(fundUuid, offeringUuid).pipe(
    map(offeringResponse => {
      const offeringState = offeringResponse.data.state?.value;
      const offeringDetailsRoutePath =
        offeringResponse.data.is_initial === false
          ? ROUTE_PATHS.OFFER_DETAILS
          : ROUTE_PATHS.INITIAL_OFFER_DETAILS;

      if (
        offeringState !== OfferingStatus.OPEN &&
        offeringState !== OfferingStatus.UPCOMING
      ) {
        router.navigate([
          ROUTE_PATHS.FUND_MANAGEMENT,
          fundUuid,
          offeringDetailsRoutePath,
          offeringUuid,
        ]);
        return false;
      }

      return true;
    }),
    catchError(() => {
      router.navigate(
        [ROUTE_PATHS.FUND_MANAGEMENT, fundUuid, ROUTE_PATHS.DETAILS],
        { queryParams: { tab: FUND_DETAILS_TABS.INVESTMENTS } }
      );
      return of(false);
    })
  );
};
